import { render, staticRenderFns } from "./dre.vue?vue&type=template&id=35b412c2&scoped=true"
import script from "./dre.vue?vue&type=script&lang=js"
export * from "./dre.vue?vue&type=script&lang=js"
import style0 from "./dre.vue?vue&type=style&index=0&id=35b412c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b412c2",
  null
  
)

export default component.exports